import * as Yup from 'yup';

export const newRoleFormSchema = Yup.object().shape({
  name: Yup.string().nullable().required().max(128),
  permission: Yup.string().nullable(),
  commentsColorPriority: Yup.string().nullable().required(),
});
